module.exports = __webpack_public_path__ + "static/media/sorry.96112325.png";